export const btnStyle =
  'h-[1.9375rem] shrink-0 grow-0 rounded-none border-0 border-b border-c-border pb-1 pl-1 pr-1.5 pt-0 text-xl hover:border-primary disabled:border-c-border/40 disabled:bg-transparent dark:hover:border-primary dark:disabled:bg-transparent';
export const btnStyleDisabled = 'cursor-default border-c-border/40 hover:border-c-border/40';
